export const css = {
	root: 'Nsv16OK7',
	card: 'JzAog8w2',
	title: 'lSy-zicJ',
	activity_intro: 'zXALYjfI',
	teach_me: 'xlVGP3EO',
	topiccalc: '_4pDcAdSP',
	topicexer: '-FLlOBKD',
	teach_me_tooltip: 'OjHFKdgq',
	quiz_me: '_4evxfvgy',
	quiz_me_tooltip: 'VUSDiFrL',
	calc_me: 'oCgsBUpW',
	exer_me: 'r9-jMUo6',
	icon: 'Sf15i4f5',
	close: 'uIToJPVy',
	skel: 'kH1-n-Oi',
	skelWithTooltip: 'vk-9BpRZ',
	enter: '-W1PRvba',
	'slide-in': 'Qrj6jI0H',
	exit: 'Wdttqay-',
	'slide-out': 'OoZ-tb0V',
	expanded_content: 'I8lwcfTI',
	twoColumn: '-wfyaYH6',
	shortDesc: 'WMu7Ed0U',
	topicgroups: 'HawwsaW0',
	item: 'YFmod6At',
	topicquiz: 'Z7c9N3Pg',
	' _key': 'card/expanded'
};

export default css;
